import { ServiceType } from '../types';

export const calcCostSum = (serviceList: ServiceType[]): number =>
  parseFloat(
    serviceList
      .reduce((sum, { price, recurrence }) => {
        if (recurrence === 'yearly') {
          return (sum += Math.round((price / 12 + Number.EPSILON) * 100) / 100);
        } else if (recurrence === 'weekly') {
          return (sum += price * 4);
        } else {
          return (sum += price);
        }
      }, 0)
      .toFixed(1)
  );
